/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Trained = props => (
  <svg width="128px" height="128px" viewBox="0 0 128 128" {...props}>
    <g>
      <path
        d="M57.02,92.283l-6.285-5.656l-8.799,1.257c-5.656,0.628-11.312-3.143-12.569-8.799l-1.256-8.169h-0.629L8,109.88
                l22.625-3.143l11.312,20.111l16.34-33.31C57.648,92.911,57.648,92.911,57.02,92.283z"
      />
      <path
        d="M101.64,70.916L101.64,70.916l-1.885,8.169c-1.258,5.027-5.657,8.799-10.685,8.799l0,0c-0.628,0-1.257,0-1.257,0
                l-8.799-1.257l-6.283,5.656c-0.629,0.628-0.629,0.628-1.257,1.256l16.339,33.31l11.313-19.483l22.623,3.143L101.64,70.916z"
      />
    </g>
    <g>
      <path
        d="M106.039,28.809l-10.685-5.027L93.47,12.469c-0.629-2.514-3.142-4.399-5.656-3.771l-11.941,1.885l-8.798-8.17
                c-1.885-1.885-5.027-1.885-6.913,0l-8.798,8.17L41.308,8.699c-3.142-0.628-5.028,1.257-5.656,3.771l-1.885,11.313l-10.684,5.027
                c-2.514,1.257-3.142,3.771-1.885,6.285l5.027,10.055l-5.027,10.055c-1.257,2.513,0,5.027,1.885,6.285l10.684,5.026l1.885,11.313
                c0.628,2.515,3.142,4.399,5.656,3.771l11.94-1.885l8.798,8.169c1.886,1.886,5.027,1.886,6.913,0l8.799-8.169l11.94,1.885
                c2.514,0.628,5.027-1.257,5.655-3.771l1.886-11.313l10.684-5.026c2.515-1.258,3.143-3.772,1.886-6.285l-6.913-10.055l5.027-10.055
                C109.182,32.58,108.554,30.066,106.039,28.809z"
      />
    </g>
  </svg>
);

export default extendIcon(Trained);
